import { type Module } from 'vuex';

import { store } from '@/store';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { type IImportStatusState } from './types';

const IMPORT_STATUS_MODULE = 'importStatus';

const importStatusModuleInstance: Module<IImportStatusState, unknown> = {
    namespaced: true,
    state: {
        asyncTaskStatus: new Map()
    },
    getters,
    actions,
    mutations
};
store.registerModule(IMPORT_STATUS_MODULE, importStatusModuleInstance);

export { IMPORT_STATUS_MODULE };
